export default "__VITE_ASSET__CpJgYj2N__"